/**
 * Class to consume WebSocket
 *
 * @class
 * @author Vvikas Gupta
 */
export default class WebShocket {
  /**
   * @constructor
   *
   * @param {String} url - Websocket url
   * @author Vvikas Gupta
   */
  constructor (url) {
    this.registerSocket(url)
  }

  /**
   * Reset connection and everything
   *
   * @method
   * @public
   * @return {undefined}
   * @author Vvikas Gupta
   */
  reset () {
    this.connection = null
    this.ready = false
    this.error = null
    this.safelyClosed = null
  }

  /**
   * Register websocket connection
   *
   * @method
   * @public
   * @param {String} url - Websocket url
   * @returns {void}
   * @author Vvikas Gupta
   */
  registerSocket (url) {
    this.reset()
    // eslint-disable-next-line
    this.connection = new WebSocket(url)

    /**
     * On connection success
     *
     * @event
     * @return {undefined}
     * @author Vvikas Gupta
     */
    this.connection.addEventListener('open', () => {
      this.ready = true
    })

    /**
     * On receiving message from serve
     *
     * @event
     * @param {Object} event - Event object
     * @return {undefined}
     * @author Vvikas Gupta
     */
    this.connection.addEventListener('message', (event) => {
      if ('onReceive' in this) {
        this.onReceive(event.data)
      }
    })

    /**
     * On error in connection
     *
     * @event
     * @param {Object} event - Event object
     * @return {undefined}
     * @author Vvikas Gupta
     */
    this.connection.addEventListener('error', (event) => {
      this.safelyClosed = false
      this.connection.close()
      setTimeout(() => {
        this.error = event.data
      }, 0)
    })

    /**
     * On connection close success
     *
     * @event
     * @return {undefined}
     * @author Vvikas Gupta
     */
    this.connection.addEventListener('close', () => {
      if (this.safelyClosed != null) {
        if (!this.safelyClosed) {
          this.registerSocket(url)
        } else {
          this.reset()
        }
      }
    })
  }

  /**
   * Send data to server
   *
   * @method
   * @public
   * @param {String} data - Data to send
   * @return {undefined}
   * @author Vvikas Gupta
   */
  send (data) {
    if (this.ready) {
      this.connection.send(data)
    }
  }

  /**
   * Close connection
   *
   * @method
   * @public
   * @return {undefined}
   * @author Vvikas Gupta
   */
  close () {
    this.safelyClosed = true
    this.connection.close()
  }
}



// WEBPACK FOOTER //
// ./src/api/WebShocket.js